import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

import postTypeItems from '@/common/api/type-items/postTypeItems';
import Snack from '@/common/components/molecules/Snack/Snack';
import { ITEM_TYPES, PRICE } from '@/common/constants';
import postInstaller from '@/ebat/api/quotes/installer/postInstaller';

const postApi = ({ reference, source, items }) =>
  new Promise((resolve, reject) => {
    postInstaller({ reference, source })
      .then((responsePostInstaller) => {
        postTypeItems({
          items: items.map((item) => ({
            coefficient: item.coefficient,
            label: item.label,
            quantity: item.quantity,
            sku: item.sku,
            type: item.type,
            type_price: PRICE.NET,
            unit_price: item.unit_price,
            vat: item.vat,
          })),
          target: responsePostInstaller,
          type: ITEM_TYPES.installer,
        })
          .then(() => {
            resolve(responsePostInstaller);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });

const useCreateQuoteInstaller = () => {
  const { t } = useTranslation();

  return useMutation(postApi, {
    onError: (error) => {
      if (error.response.status === 500) {
        toast.error(
          <Snack message={t('common:messages:forms.errors.server_error')} />,
        );
      } else {
        toast.error(
          <Snack message={t('common:messages:forms.errors.default')} />,
        );
      }
    },
    onSuccess: () => {
      toast.success(
        <Snack message={t('common:messages:forms.success.default')} />,
      );
    },
  });
};

export default useCreateQuoteInstaller;
